export const OPEN_AI_ASSISTANT = 'OPEN_AI_ASSISTANT';
export const CLOSE_AI_ASSISTANT = 'CLOSE_AI_ASSISTANT';
export const SET_AI_ASSISTANT_MODE = 'SET_AI_ASSISTANT_MODE';
export const OPEN_AI_ASSISTANT_WITH_PROMPT = 'OPEN_AI_ASSISTANT_WITH_PROMPT';
export const CLEAR_AI_ASSISTANT_PROMPT = 'CLEAR_AI_ASSISTANT_PROMPT';
export const SET_AI_ASSISTANT_TOKEN_LIMIT_REACHED = 'SET_AI_ASSISTANT_TOKEN_LIMIT_REACHED';
